import React from "react";

const HeroSection = () => {
  return (
    <section className="relative w-full py-20 md:py-32 bg-white overflow-hidden">

      {/* Floating Food Images */}
      <img
        src="/images/burger.png"
        alt="burger"
        className="absolute left-5 md:left-20 top-36 md:top-52 w-32 md:w-44 animate-float"
      />

      <img
        src="/images/momo.png"
        alt="momo"
        className="absolute right-5 md:right-20 top-20 md:top-32 w-32 md:w-40 animate-float-delayed"
      />

      <img
        src="/images/pizza.png"
        alt="pizza"
        className="absolute right-10 bottom-20 w-40 animate-float-slow"
      />

      <img
        src="/images/tomato.png"
        alt="tomato"
        className="absolute left-10 bottom-32 w-10 opacity-80 animate-spin-slow"
      />

      <img
        src="/images/leaf.png"
        alt="leaf"
        className="absolute left-1/2 w-10 opacity-80 top-10 animate-float"
      />

      {/* Background curve line */}
      <div className="absolute inset-0 pointer-events-none">
        <svg
          className="absolute w-full h-full opacity-50"
          viewBox="0 0 800 400"
        >
          <path
            d="M10 50 C150 200 400 0 600 200"
            stroke="#F9B3C5"
            strokeWidth="3"
            fill="none"
          />
        </svg>
      </div>

      {/* MAIN CONTENT */}
      <div className="relative text-center max-w-3xl mx-auto px-6">
        <h1 className="text-4xl md:text-5xl font-bold text-red-500 leading-tight">
          Better food for
          <br />
          more people
        </h1>

        <p className="text-gray-600 text-lg md:text-xl mt-5">
          For over a decade, we’ve enabled our customers to discover new tastes,
          delivered right to their doorstep
        </p>
      </div>

      {/* Animations */}
      <style>{`
        .animate-float {
          animation: float 4s ease-in-out infinite;
        }
        .animate-float-delayed {
          animation: float 4.5s ease-in-out infinite;
        }
        .animate-float-slow {
          animation: float 6s ease-in-out infinite;
        }
        .animate-spin-slow {
          animation: spin 5s linear infinite;
        }

        @keyframes float {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-15px); }
        }

        @keyframes spin {
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </section>
  );
};

export default HeroSection;
